import { render } from "./WohnungStep3.vue?vue&type=template&id=f67347a4"
import script from "./WohnungStep3.vue?vue&type=script&lang=js"
export * from "./WohnungStep3.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__